export default "__VITE_ASSET__$ta7SPQR__"